// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-bootstrap-index-js": () => import("/apps01/Jenkins/workspace/fox.uikit/fox.uikit.deploy.nonprod/src/pages/bootstrap/index.js" /* webpackChunkName: "component---src-pages-bootstrap-index-js" */),
  "component---src-pages-index-js": () => import("/apps01/Jenkins/workspace/fox.uikit/fox.uikit.deploy.nonprod/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-slds-index-js": () => import("/apps01/Jenkins/workspace/fox.uikit/fox.uikit.deploy.nonprod/src/pages/slds/index.js" /* webpackChunkName: "component---src-pages-slds-index-js" */)
}

